import React from 'react'; 
import './styles.less';     
 
const Header = ( { backURL } ) => {

    // const handleBackClick = () => {
    //     window.location = backURL;
    // };

    return (
        <header> 
            <div className="flex-row">
                <div className="flex-row-left">
                    <img 
                        className="logo"
                        aria-label="Logo image"
                    />
                </div>
                
                { /* <div className="flex-row-right">
                    <Button 
                        className="toggle-button selected"
                        onClick={ handleBackClick }
                    >
                        { getString( 'player.button.back' ) }
                    </Button>
                </div> */ } 
            </div>
        </header>
    );
};

export default Header;
